module.exports = __webpack_public_path__ + "public-ui/img/g1.dccda95e.svg";